import type {ConnectElementConfig} from '../ConnectElementList';

export const TreasuryReactivationConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "treasuryReactivation" */
      '../../../components/MoneyManagement/TreasuryReactivation/TreasuryReactivation'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  description:
    'Module to prompt for needed step-up compliance actions or to promote a new feature.',
  friendlyName: 'Treasury Reactivation Module',
};
